var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseDialogSign',{attrs:{"rgbaSignBorderColor":"rgba(225, 170, 121, 0.7)","hexSignCoreColor":"#E1AA79"}})}
var staticRenderFns = []

export { render, staticRenderFns }